// extracted by mini-css-extract-plugin
module.exports = {"universeAddBtn":"styles__universeAddBtn--o40Io","deleteBtn":"styles__deleteBtn--3B2OT"};